export default __webpack_public_path__ + "094157877b0c1b2e1428070554cf3604.svg";